import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { OtpModalService } from '../otp-modal.service';
import { ErrorMsgService } from '../../error-msg/error-msg.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-otp-modal',
  templateUrl: './otp-modal.component.html',
  styleUrls: ['./otp-modal.component.scss']
})
export class OtpModalComponent {
  @Input() latestCashedSecuredApiData: any; // Receive API data

  viewFLag: string = 'scan';
  email: string = localStorage.getItem('userMail')
  otp
  isOtpEntered = false;
  pauseResending = false;
  timeLeft: number = 60;
  formattedTime: string = '01:00';
  private timerInterval: any; // Store interval reference
  showError: boolean = false;
  errorMsg: string = ''
  apiResponse: any;
  loading: boolean = false;
  shakeOtp: boolean = false;
  showContactSupportDialog: boolean = false;
  supportEmail: string = 'info@blueride.co';
  emailCopied: boolean = false;
  private emailCopiedTimeout: any;

  private subscriptions: Subscription = new Subscription();
  private isSubscribed = false; // Track if already subscribed
  constructor(private otpModalService: OtpModalService, private errorMsgService: ErrorMsgService,
    private globalService: GlobalService
  ) {

  }

  ngOnInit() {
  }

  /**
   * Sends OTP to user via mail
   *
   * @description
   * When user click on send OTP button, this function will be called
   * and it will call OTP service to send OTP to user via mail
   * If OTP is sent successfully, then it will show verify OTP section
   * else it will show error message
   * @returns {void}
   */
  sendOtp() {
    this.loading = true;
    this.otpModalService.sendOtpToUserViaMail().subscribe(res => {
      this.loading = false;
      this.viewFLag = 'verify';
    }, err => {
      this.loading = false;
      this.errorMsgService.setMessage(err?.error?.message);
    })
  }


  /**
   * Verify OTP
   *
   * When user click on verify OTP button, this function will be called
   * if the user clicks the verify OTP button without entering OTP, call the shake effect function which shake the otp input field
   * and if the user clicks the verify OTP button with entered OTP, it will call OTP service to retry with OTP
   * If OTP is verified successfully, then it will close the modal
   * else it will call error handler function
   * @returns {void}
   */
  verfiyOtp() {
    if (!this.isOtpEntered) {
      this.triggerShakeEffect();
      return;
    }
    this.loading = true;
    localStorage.setItem('OTP', this.otp);
    this.otpModalService.retryWithOtp(this.latestCashedSecuredApiData?.method, this.latestCashedSecuredApiData?.url, this.latestCashedSecuredApiData?.body).subscribe(res => {
      this.loading = false;
      this.closeModal();
    }, err => {
      this.otpVerificationErrorHandler(err)
    })
  }


  isValidOTP(otp: string | number): boolean {
    // Convert to string if it's a number
    const otpStr = otp.toString().trim();

    // Arabic and English digits regex
    const otpRegex = /^[0-9٠-٩]+$/;

    return otpRegex.test(otpStr);
  }

  /**
   * Called when user enters OTP
   *
   * @param event contains the OTP entered by user
   * @description
   * When user enters OTP, this function will be called
   * It will reset the error flag and restore the OTP input field styles
   * It will also update the OTP value and check if the OTP length is correct and vaild format
   * @returns {void}
   */
  onOtpEntered(otp: string) {
    this.showError = false;
    this.checkOtpLengthAndValidity(otp);
  }


  /*************  ✨ Codeium Command ⭐  *************/
  /**
   * Checks if the OTP length is correct and valid
   * @param otp - The OTP entered by the user
   * @description
   * This function checks if the OTP length is 6 and if it's valid.
   * If the OTP length is 6, it checks if the OTP is valid by calling the isValidOTP function.
   * If the OTP is valid, it sets the OTP value and sets the isOtpEntered flag to true.
   * If the OTP is invalid, it sets the isOtpEntered flag to false and shows an error message.
   * If the OTP length is not 6, it sets the isOtpEntered flag to false.
   */
  /******  8097a1df-ec03-4a8c-8b86-63d0468fba16  *******/
  checkOtpLengthAndValidity(otp) {
    if (otp.length == 6) {
      if (this.isValidOTP(otp)) {
        this.otp = this.sanitizeOTPAsEnglishNumsForBackend(otp)
        this.isOtpEntered = true;
      }
      else {
        let invalidMsg = localStorage.getItem('lang') == 'en' ? "Invalid OTP Format" : "صيغة رمز التحقق غير صحيحة";
        this.isOtpEntered = false;
        this.otpInputError(invalidMsg);
      }
    }
    else {
      this.isOtpEntered = false;
    }
  }

  /*************  ✨ Codeium Command ⭐  *************/
  /**
   * Sanitizes the OTP by replacing Arabic digits with English digits
   * @param otp - The OTP entered by the user
   * @returns The sanitized OTP as a string
   * @description
   * This function takes an OTP as a string or number, converts it to a string if it's a number, and
   * replaces Arabic digits with English digits. It's used to sanitize the OTP for the backend API.
   */
  /******  175892f5-f465-49eb-8498-783fe92074ec  *******/
  sanitizeOTPAsEnglishNumsForBackend(otp: string | number): string {
    // Convert to string if it's a number
    let otpStr = otp.toString().trim();

    // Arabic to English digit mapping
    const arabicToEnglishMap: { [key: string]: string } = {
      "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
      "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9"
    };

    // Replace Arabic digits with English digits
    otpStr = otpStr.replace(/[٠-٩]/g, (digit) => arabicToEnglishMap[digit]);

    return otpStr;
  }

  /**
   * Opens the Freshchat-widget when the user clicks on the "Contact Support" button.
   * @description
   * This function is called when the user clicks on the "Contact Support" button.
   * It opens the FreshChat widget
   * @returns {void}
   */
  // openChat() {
  //   window['fcWidget']?.open();
  // }

  /**
   * Opens an in-modal dialog that displays the support email with a
   * copy-to-clipboard button. This avoids relying on a local mail client
   * (which Smart TVs don't have) or assuming a specific webmail provider.
   * @returns {void}
   */
  openContactSupportDialog() {
    this.showContactSupportDialog = true;
    this.emailCopied = false;
  }

  closeContactSupportDialog() {
    this.showContactSupportDialog = false;
    this.emailCopied = false;
    if (this.emailCopiedTimeout) {
      clearTimeout(this.emailCopiedTimeout);
      this.emailCopiedTimeout = null;
    }
  }

  copySupportEmail() {
    const onSuccess = () => {
      this.emailCopied = true;
      if (this.emailCopiedTimeout) clearTimeout(this.emailCopiedTimeout);
      this.emailCopiedTimeout = setTimeout(() => this.emailCopied = false, 2000);
    };

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(this.supportEmail)
        .then(onSuccess)
        .catch(() => this.fallbackCopyEmail(onSuccess));
    } else {
      this.fallbackCopyEmail(onSuccess);
    }
  }

  // Fallback for browsers without navigator.clipboard (older Smart TV browsers).
  private fallbackCopyEmail(onSuccess: () => void) {
    const textarea = document.createElement('textarea');
    textarea.value = this.supportEmail;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      if (document.execCommand('copy')) onSuccess();
    } catch { /* no-op: email is still visible on screen */ }
    document.body.removeChild(textarea);
  }

  /**
   * Resends the OTP and starts the resend timer
   *
   * @description
   * This function is called when the user clicks on the "Resend OTP" button.
   * It sets the pauseResending flag to true wich hide the resend button and show a timer to replace it , starts the timer and then calls the sendOtp function
   * @returns {void}
   */
  resendOtp() {
    this.pauseResending = true;
    this.startTimer();
    this.sendOtp();
  }

  /**
   * Starts the resend OTP timer
   *
   * @description
   * This function starts a timer that counts down from 60 seconds
   * and updates the formattedTime variable with the current time left
   * It also clears any existing timer interval to prevent multiple timers
   * from running at the same time.
   * When the timer reaches 0, it clears the interval and sets the pauseResending flag to false which hide the timer and show the resend button again.
   * @returns {void}
   */
  startTimer() {
    this.pauseResending = true;
    this.timeLeft = 60;
    this.updateFormattedTime();
    // Clear any existing interval before starting a new one
    this.clearTimer();
    this.timerInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.updateFormattedTime();
      } else {
        this.clearTimer();
        this.pauseResending = false;
      }
    }, 1000);
  }

  /**
   * Updates the formattedTime variable with the current time left in the timer
   * in the format MM:SS. If the language is Arabic, it converts the numbers to
   * Arabic numerals.
   * @returns {void}
   */
  updateFormattedTime() {
    const minutes = Math.floor(this.timeLeft / 60).toString().padStart(2, '0');
    const seconds = (this.timeLeft % 60).toString().padStart(2, '0');
    const formatted = `${minutes}:${seconds}`;
    this.formattedTime = localStorage.getItem('lang') == 'ar' ? this.toArabicNumerals(formatted) : formatted;
  }

  /**
   * Replaces all numbers in the given string with their Arabic numerals equivalents.
   * @param num The string passed from the function updateFormattedTime to replace numbers in 
   * @returns The string with all numbers replaced with Arabic numerals
   */
  toArabicNumerals(num: string): string {
    return num.replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[+d]);
  }


  /**
   * Clears the resend OTP timer interval
   *
   * @description
   * This function is used to clear the resend OTP timer interval
   * It is called when the user closes the modal or when the resend OTP
   * button is clicked again
   * @returns {void}
   */
  clearTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  /**
   * Destroys the modal component and all its associated resources
   * @description
   * This lifecycle hook is called when the component is destroyed
   * It is used to clean up any resources that the component is using
   * In this case, it is used to close the modal
   * @returns {void}
   */
  ngOnDestroy() {
    this.closeModal();
  }

  /**
   * Handles errors that occur during OTP verification
   *
   * @param err The error object that contains the error message
   * @description
   * This function is called when an error occurs during OTP verification
   * If the error status is 424 (Failed dependency), it sets the input style of the OTP input field to the error style,
   * sets the error message and shows the error message
   * If the error status is not 424, it sets the error message and shows the error message popup
   * this to seperate the verification errors from the business api errors
   * @returns {void}
   */
  otpVerificationErrorHandler(err) {
    this.loading = false;
    if (err.status === 424) {
      this.otpInputError(err.error.message)
    }
    else {
      this.errorMsgService.setMessage(err?.error?.message);
    }
  }

  /**
   * Sets the error message of the OTP input field and shows the error message.
   *
   * @param msg The error message to be displayed.
   * @description
   * This function is called when an error occurs during OTP verification.
   * It sets the error message and shows the error message.
   * @returns {void}
   */
  otpInputError(msg) {
    this.errorMsg = msg;
    this.showError = true;
  }

  /**
   * Triggers the shake effect animation on the OTP input field.
   *
   * @description
   * This function is called if the user clicks on the disabled vrify button without entering OTP.
   * It sets the shakeOtp flag to true which triggers the animation,
   * and then sets it back to false after a 400ms delay to match the animation duration.
   * @returns {void}
   */
  triggerShakeEffect() {
    this.shakeOtp = true;
    setTimeout(() => {
      this.shakeOtp = false;
    }, 400); // Match the duration of your animation
  }


  /**
   * Closes the OTP modal component and all its associated resources
   *
   * @description
   * This function is called when the user closes the OTP modal
   * It resets all the component properties, clears the timer, unsubscribes from observables and calls the closeOtp method of the OTP service
   * to destroy the modal
   * @returns {void}
   */

  cancelOtpVerfication() {
    // to hide the floating progress bar (preparing your file ) in case of cancellation of the otp verification
    this.globalService.setExportAlert('');
    this.globalService.setUploadSheet('');
    // this.globalService.setPrintQrAlert('');
    // this.globalService.setApproveAllRequests('');
    this.closeModal();
  }
  closeModal() {
    this.otp = null;
    localStorage.removeItem('OTP');
    this.clearTimer();
    this.showError = false;
    this.shakeOtp = false;
    this.closeContactSupportDialog();
    // Unsubscribe from observables to prevent memory leaks
    this.subscriptions.unsubscribe();
    this.isSubscribed = false; // Reset subscription state
    this.otpModalService.closeOtp();
  }
}
